import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';

import NoShipmentsYet from '../NoShipmentsYet/NoShipmentsYet';
import useUnsuccessfulDeliveries from './useUnsuccessfulDeliveries';

const UnsuccessfulDeliveries = () => {
  const hook = useUnsuccessfulDeliveries();
  return (
    <Card sx={{ p: 3, borderRadius: 3, boxShadow: 2, height: '100%' }}>
      <Typography variant="body1" sx={{ fontWeight: 600, mb: '1rem' }}>
        Desglose de entregas no exitosas
      </Typography>
      {hook.data.data?.length === 0 ? (
        <NoShipmentsYet />
      ) : (
        <ResponsiveContainer width="100%" height={280}>
          <PieChart width={400} height={200}>
            <Legend
              layout="vertical"
              align="left"
              verticalAlign="middle"
              width={200}
              wrapperStyle={{ fontSize: '1rem', lineHeight: '1.5rem' }}
            />
            <Pie
              data={hook.data.data!}
              dataKey="count"
              nameKey="reason"
              cx="50%"
              cy="50%"
              outerRadius={100}
              innerRadius={30}
              startAngle={90}
              endAngle={-270}
              fill="#8884d8"
            >
              {hook.data.data?.map((_, index) => (
                <Cell key={`cell-${index}`} fill={'#6fd3a6'} />
              ))}
            </Pie>
            <Tooltip />
          </PieChart>
        </ResponsiveContainer>
      )}
    </Card>
  );
};

export default UnsuccessfulDeliveries;
